@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

@layer chart {
  .indicatorItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    @include border-radius-r1;
    width: 100%;
    padding: 8px;
    cursor: pointer;
    border: none;
    background: none;

    &:hover {
      background-color: var(--surface-hover);
    }

    &,
    &:focus-visible {
      outline: none;
    }

    &.focused,
    &.focused:focus-visible {
      outline: 2px solid var(--border-focus);
    }
  }

  .indicatorText {
    @include typography-v2-body-sm;
    text-align: left;
    color: var(--text-default);
  }

  .secondary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    max-width: 200px;
  }

  .indicatorSmallText {
    @include typography-v2-body-xs;
    text-align: right;
    color: var(--text-soft);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
